var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5761 1.45076C11.8104 1.21645 12.1903 1.21645 12.4246 1.45076L16.9246 5.95076C17.1589 6.18507 17.1589 6.56497 16.9246 6.79929C16.6903 7.0336 16.3104 7.0336 16.0761 6.79929L12.6001 3.32336V13.125C12.6001 13.4564 12.3315 13.725 12.0001 13.725C11.6688 13.725 11.4001 13.4564 11.4001 13.125V3.32375L7.92461 6.79929C7.69029 7.0336 7.31039 7.0336 7.07608 6.79929C6.84176 6.56497 6.84176 6.18507 7.07608 5.95076L11.5761 1.45076ZM4.12515 11.35C3.8352 11.35 3.60015 11.5851 3.60015 11.875V21C3.60015 21.29 3.8352 21.525 4.12515 21.525H19.8751C20.1651 21.525 20.4001 21.29 20.4001 21V11.875C20.4001 11.5851 20.1651 11.35 19.8751 11.35H17.6251C17.2938 11.35 17.0251 11.0814 17.0251 10.75C17.0251 10.4187 17.2938 10.15 17.6251 10.15H19.8751C20.8278 10.15 21.6001 10.9223 21.6001 11.875V21C21.6001 21.9527 20.8278 22.725 19.8751 22.725H4.12515C3.17246 22.725 2.40015 21.9527 2.40015 21V11.875C2.40015 10.9223 3.17246 10.15 4.12515 10.15H6.37515C6.70652 10.15 6.97515 10.4187 6.97515 10.75C6.97515 11.0814 6.70652 11.35 6.37515 11.35H4.12515Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.56c12978b661e409f6013403cdfb0241.svg";
export { ForwardRef as ReactComponent };